export const environment = {
  production: false,
  buildVersion: '1.0.0',
  defaultauth: 'fackbackend',
  firebaseConfig: {
    apiKey: '',
    authDomain: '',
    databaseURL: '',
    projectId: '',
    storageBucket: '',
    messagingSenderId: '',
    appId: '',
    measurementId: ''
  },
  url: {
    BASE_URL: 'https://denali.cerebrumx.ai/d1/api/v1/cms/',
    API_URL: 'https://denali.cerebrumx.ai/d1/api/v1/',
    CHAT_BOT: 'https://denali.cerebrumx.ai/d1/api/',
    authUrl: 'https://denali.cerebrumx.ai/d1/api/v1/',
    apiUrlv3: 'https://denali.cerebrumx.ai/d1/api/v3/',
    Bulk_eligibility: 'https://denali.cerebrumx.ai/d1/api/v3/',
    apiUpdateUrl: 'https://denali.cerebrumx.ai/d1/api/v4/',
    webApi: 'wss://denali.cerebrumx.ai/d1/api/chatbot/ws/stream/'

    // BASE_URL: 'https://denali.cerebrumx.ai/du1/api/v1/cms/',
    // API_URL: 'https://denali.cerebrumx.ai/du1/api/v1/',
    // CHAT_BOT: 'https://denali.cerebrumx.ai/du1/api/',
    // authUrl: 'https://denali.cerebrumx.ai/du1/api/v1/',
    // apiUrlv3: 'https://denali.cerebrumx.ai/du1/api/v3/',
    // Bululk_eligibility: 'https://denali.cerebrumx.ai/du1/v3/',
    // Bulk_eligibility: 'https://denali.cerebrumx.ai/du1/api/v3/',
    // apiUpdateUrl: 'https://denali.cerebrumx.ai/du1/api/v4/',
    // webApi: 'wss://denali.cerebrumx.ai/du1/api/chatbot/ws/stream/'

  },

  //  url: {
  //  BASE_URL: 'http://localhost:8092/d1/api/v1/cms/',
  //   API_URL: 'http://localhost:8092/d1/api/v1/',
  //   CHAT_BOT: 'http://localhost:8092/d1/api/',
  //   authUrl: 'http://localhost:8092/d1/api/v1/',
  //   apiUrlv3: 'http://localhost:8092/d1/api/v3/',
  //   Bulk_eligibility: 'http://localhost:8092/d1/api/v3/',
  //   apiUpdateUrl: 'http://localhost:8092/d1/api/v4/',

  // },

};